module.exports = __webpack_public_path__ + "static/media/CenturyGothic.602bdeb6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CenturyGothic.woff
// module id = 12
// module chunks = 0